Mixins.propertyJSON = {
    data: function () {
        return {
            property: {}
        }
    },
    mounted: function () {
        this.property = JSON.parse(document.getElementById('property-data').innerHTML);
    }
};